<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">عنوان الحدث</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "eventForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الحدث</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                
                                     required
                                     placeholder="الحدث"
                                    containerClass="" />
                            </div>

                            



                            <!-- الموقع -->
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> الموقع</label>
                                <input class="form-control" id="validation03" type="text" formControlName="location"
                                [tooltip]="fc.location.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.location.valid && (fc.location.touched)"
                                [class.is-invalid]="fc.location.invalid && (fc.location.touched)"
                                     required
                                    
                                     placeholder="الموقع"
                                    containerClass="" 
                                    />
                            </div>
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> رابط المقطع</label>
                                <input class="form-control" id="validation03" type="text" formControlName="videourl"
                                [tooltip]="fc.videourl.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.videourl.valid && (fc.videourl.touched)"
                                [class.is-invalid]="fc.videourl.invalid && (fc.videourl.touched)"
                                     required
                                    
                                     placeholder="https://www.example.com"
                                    containerClass="" 
                                    />
                            </div>
                                                             <!-- select keyword -->
                     <div class="col-lg-6 col-sm-12  mb-3" style="margin-top: 7px;">
                        <label for="validationCustom06"> كلمات دليلية</label>
                        <ng-multiselect-dropdown
                               formControlName="keywords"
                               [placeholder]="'اختر كلمة '"
                               [settings]="dropdownSettings"
                               [data]="keyword"
                               [(ngModel)]="selectedItems"
                               (onDeSelect)="onItemDeSelect($event)"
                               (onDeSelectAll)="onUnSelectAll($event)"
                               (onSelect)="onItemSelect($event)"
                               (onSelectAll)="onSelectAll($event)">
                                         </ng-multiselect-dropdown>
                    </div>
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> من تاريخ</label>
                                <input class="form-control" id="validation03" type="date" formControlName="datetimeFrom"
                                [tooltip]="fc.datetimeFrom.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.datetimeFrom.valid && (fc.datetimeFrom.touched)"
                                [class.is-invalid]="fc.datetimeFrom.invalid && (fc.datetimeFrom.touched)"
                                     required
                                     appDisableWeritingArabic
                                     placeholder=""
                                    containerClass="" 
                                    />
                            </div>
                            
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> الى تاريخ</label>
                                <input class="form-control" id="validation03" type="date" formControlName="datetimeTo"
                                [tooltip]="fc.datetimeTo.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.datetimeTo.valid && (fc.datetimeTo.touched)"
                                [class.is-invalid]="fc.datetimeTo.invalid && (fc.datetimeTo.touched)"
                                     required
                                     appDisableWeritingArabic
                                     placeholder=""
                                    containerClass="" 
                                    />
                            </div>
                   
                            
                    <!-- المحتوى       -->
                    <div class="col-12 mb-3">
                        <label for="validation03"><span class="validation-required">*</span> المحتوى</label>
                 <angular-editor [placeholder]="'بالرجاء كتابة المحتوى هنا.....'" [config]="editorConfig" 
                 formControlName="body"></angular-editor>
                    </div>
                         <!-- to insert image  -->
                         <div class="col-6 my-3 " >
                                <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                
                             
                               <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                                style="display: none" (change)="getLogoUrl($event)" />
                            <button type="button" onclick="document.getElementById('getLogo').click()"
                                class="btn   d-block"  style="width: 60%;">
                                ارفاق صورة
                            </button>    
                                
                              
                                          
                                        </div>
                            

                        </div>
                   
                        
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

